import { memo, useEffect, useRef, useState } from "react";

export const PdfPage = memo(function PdfPage({ pdf, num, size, scale, highlights, activeMatch, rootRef, pageRef }) {
  const wrapRef = useRef(null);
  const canvasRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = wrapRef.current;
    pageRef(num, el);
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); },
      { root: rootRef.current, rootMargin: "800px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, [num, rootRef, pageRef]);

  useEffect(() => {
    if (!visible) return;
    let task; let cancelled = false;
    pdf.getPage(num).then((page) => {
      if (cancelled || !canvasRef.current) return;
      const vp = page.getViewport({ scale });
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const c = canvasRef.current;
      c.width = Math.floor(vp.width * dpr);
      c.height = Math.floor(vp.height * dpr);
      task = page.render({ canvasContext: c.getContext("2d"), viewport: vp, transform: dpr !== 1 ? [dpr, 0, 0, dpr, 0, 0] : null });
      task.promise.catch(() => {});
    });
    return () => { cancelled = true; task?.cancel(); };
  }, [pdf, num, scale, visible]);

  return (
    <div ref={wrapRef} className="relative bg-white shadow-lg mx-auto" data-testid={`pdf-page-${num}`}
      style={{ width: size.w * scale, height: size.h * scale }}>
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full" />
      {highlights.map((h, i) => (
        <div key={i} className={`absolute pointer-events-none rounded-[2px] ${h.m === activeMatch ? "bg-orange-500/50 ring-2 ring-orange-500" : "bg-yellow-300/50"}`}
          data-testid={h.m === activeMatch ? "pdf-highlight-active" : "pdf-highlight"}
          style={{ left: h.x * scale - 1, top: h.y * scale - 1, width: h.w * scale + 2, height: h.h * scale + 2 }} />
      ))}
      <span className="absolute top-1 right-1 text-[10px] font-mono bg-slate-900/70 text-white px-1 rounded-sm">{num}</span>
    </div>
  );
});
